/* eslint-disable import/prefer-default-export */
export const MONEY_BACK_GUARANTEE_DAYS = 7
